// import React, { useState, useEffect } from 'react';
// import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
// import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
// import { db } from './firebaseConfig';

// const UploadArticle = () => {
//   const [title, setTitle] = useState('');
//   const [mainDescription, setMainDescription] = useState('');
//   const [subtopics, setSubtopics] = useState([
//     { id: Date.now(), heading: '', description: '', imageFile: null, imagePreview: null },
//   ]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');

//   useEffect(() => {
//     if (success) {
//       const timer = setTimeout(() => setSuccess(''), 5000);
//       return () => clearTimeout(timer);
//     }
//   }, [success]);

//   const handleAddSubtopic = () => {
//     setSubtopics((prev) => [
//       ...prev,
//       { id: Date.now(), heading: '', description: '', imageFile: null, imagePreview: null },
//     ]);
//   };

//   const handleRemoveSubtopic = (id) => {
//     setSubtopics((prev) => prev.filter((sub) => sub.id !== id));
//   };

//   const handleSubtopicChange = (id, field, value) => {
//     setSubtopics((prev) =>
//       prev.map((sub) => (sub.id === id ? { ...sub, [field]: value } : sub))
//     );
//   };

//   const handleImageChange = (id, file) => {
//     if (file && file.type.startsWith('image/')) {
//       const previewUrl = URL.createObjectURL(file);
//       setSubtopics((prev) =>
//         prev.map((sub) =>
//           sub.id === id ? { ...sub, imageFile: file, imagePreview: previewUrl } : sub
//         )
//       );
//     }
//   };

//   const validateForm = () => {
//     if (!title.trim()) {
//       setError('Please enter the main article title.');
//       return false;
//     }

//     for (let i = 0; i < subtopics.length; i++) {
//       const sub = subtopics[i];
//       if (!sub.heading.trim()) {
//         setError(`Subtopic #${i + 1}: Heading is required.`);
//         return false;
//       }
//       if (!sub.description.trim()) {
//         setError(`Subtopic #${i + 1}: Description is required.`);
//         return false;
//       }
//     }
//     return true;
//   };

//   // Upload image to Firebase Storage and return the download URL
//   const uploadImageAndGetUrl = async (file) => {
//     if (!file) return null;
//     const storage = getStorage();
//     const storageRef = ref(storage, `articleImages/${file.name}_${Date.now()}`);
//     await uploadBytes(storageRef, file);
//     const url = await getDownloadURL(storageRef);
//     return url;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     setError('');
//     setSuccess('');

//     if (!validateForm()) return;

//     setLoading(true);

//     try {
//       // Upload images and get their URLs
//       const subtopicsWithImages = await Promise.all(
//         subtopics.map(async (sub) => {
//           const imageUrl = sub.imageFile ? await uploadImageAndGetUrl(sub.imageFile) : null;
//           return {
//             heading: sub.heading.trim(),
//             description: sub.description.trim(),
//             imageUrl,
//           };
//         })
//       );

//       await addDoc(collection(db, 'articles'), {
//         title: title.trim(),
//         mainDescription: mainDescription.trim(),
//         subtopics: subtopicsWithImages,
//         createdAt: serverTimestamp(),
//       });

//       setSuccess('Article uploaded successfully!');
//       setTitle('');
//       setMainDescription('');
//       setSubtopics([{ id: Date.now(), heading: '', description: '', imageFile: null, imagePreview: null }]);
//     } catch (err) {
//       setError(`Failed to upload article: ${err.message}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <main className="max-w-3xl mx-auto p-4 font-sans">
//       <h1 className="text-3xl font-bold mb-6 text-center text-gray-800">Upload Article</h1>

//       <form onSubmit={handleSubmit} noValidate>
//         {/* Main Title */}
//         <div className="mb-6">
//           <label htmlFor="title" className="block text-lg font-semibold text-gray-700 mb-2">
//             Main Title <span className="text-red-600">*</span>
//           </label>
//           <input
//             id="title"
//             type="text"
//             value={title}
//             onChange={(e) => setTitle(e.target.value)}
//             disabled={loading}
//             placeholder="Enter main article title"
//             className="w-full border border-gray-300 rounded-md p-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
//             maxLength={150}
//             required
//           />
//           <p className="text-sm text-gray-500 mt-1">{title.length} / 150 characters</p>
//         </div>

//         {/* Main Description (optional) */}
//         <div className="mb-8">
//           <label htmlFor="mainDescription" className="block text-lg font-semibold text-gray-700 mb-2">
//             Main Description (optional)
//           </label>
//           <textarea
//             id="mainDescription"
//             value={mainDescription}
//             onChange={(e) => setMainDescription(e.target.value)}
//             disabled={loading}
//             rows={4}
//             placeholder="Optional description for the article"
//             className="w-full border border-gray-300 rounded-md p-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
//             maxLength={500}
//           />
//           <p className="text-sm text-gray-500 mt-1">{mainDescription.length} / 500 characters</p>
//         </div>

//         {/* Subtopics */}
//         <div>
//           <h2 className="text-2xl font-semibold mb-4 text-gray-800">Subtopics</h2>

//           {subtopics.map((subtopic, index) => (
//             <div
//               key={subtopic.id}
//               className="border border-gray-300 rounded-md p-4 mb-6 relative bg-white shadow-sm"
//             >
//               <div className="flex justify-between items-center mb-4">
//                 <h3 className="text-xl font-semibold text-gray-700">
//                   Subtopic #{index + 1}
//                 </h3>
//                 {subtopics.length > 1 && (
//                   <button
//                     type="button"
//                     onClick={() => handleRemoveSubtopic(subtopic.id)}
//                     disabled={loading}
//                     className="text-red-600 hover:text-red-800 focus:outline-none"
//                     aria-label={`Remove subtopic #${index + 1}`}
//                   >
//                     &times;
//                   </button>
//                 )}
//               </div>

//               {/* Subtopic Heading */}
//               <div className="mb-4">
//                 <label
//                   htmlFor={`subHeading-${subtopic.id}`}
//                   className="block font-medium text-gray-700 mb-1"
//                 >
//                   Subtopic Heading <span className="text-red-600">*</span>
//                 </label>
//                 <input
//                   id={`subHeading-${subtopic.id}`}
//                   type="text"
//                   value={subtopic.heading}
//                   onChange={(e) =>
//                     handleSubtopicChange(subtopic.id, 'heading', e.target.value)
//                   }
//                   disabled={loading}
//                   maxLength={100}
//                   placeholder="Enter subtopic heading"
//                   className="w-full border border-gray-300 rounded-md p-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   required
//                 />
//                 <p className="text-sm text-gray-500 mt-1">
//                   {subtopic.heading.length} / 100 characters
//                 </p>
//               </div>

//               {/* Subtopic Description */}
//               <div className="mb-4">
//                 <label
//                   htmlFor={`subDescription-${subtopic.id}`}
//                   className="block font-medium text-gray-700 mb-1"
//                 >
//                   Description <span className="text-red-600">*</span>
//                 </label>
//                 <textarea
//                   id={`subDescription-${subtopic.id}`}
//                   value={subtopic.description}
//                   onChange={(e) =>
//                     handleSubtopicChange(subtopic.id, 'description', e.target.value)
//                   }
//                   disabled={loading}
//                   rows={5}
//                   maxLength={1500}
//                   placeholder="Write the subtopic description"
//                   className="w-full border border-gray-300 rounded-md p-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
//                   required
//                 />
//                 <p className="text-sm text-gray-500 mt-1">
//                   {subtopic.description.length} / 1500 characters
//                 </p>
//               </div>

//               {/* Subtopic Image Upload (optional) */}
//               <div className="mb-2">
//                 <label
//                   htmlFor={`subImage-${subtopic.id}`}
//                   className="block font-medium text-gray-700 mb-1"
//                 >
//                   Optional Image
//                 </label>
//                 <input
//                   id={`subImage-${subtopic.id}`}
//                   type="file"
//                   accept="image/*"
//                   disabled={loading}
//                   onChange={(e) =>
//                     handleImageChange(subtopic.id, e.target.files?.[0] || null)
//                   }
//                   className="block"
//                 />
//               </div>

//               {/* Image Preview */}
//               {subtopic.imagePreview && (
//                 <div className="mt-2">
//                   <img
//                     src={subtopic.imagePreview}
//                     alt={`Preview for subtopic #${index + 1}`}
//                     className="max-w-full max-h-48 rounded-md border border-gray-300"
//                   />
//                 </div>
//               )}
//             </div>
//           ))}

//           <button
//             type="button"
//             onClick={handleAddSubtopic}
//             disabled={loading}
//             className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
//           >
//             + Add Subtopic
//           </button>
//         </div>

//         {/* Submit */}
//         <div className="mt-8">
//           <button
//             type="submit"
//             disabled={loading}
//             className={`w-full py-3 text-lg font-semibold rounded-md text-white ${
//               loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'
//             } focus:outline-none focus:ring-2 focus:ring-green-500`}
//             aria-busy={loading}
//           >
//             {loading ? 'Uploading...' : 'Upload Article'}
//           </button>
//         </div>

//         {/* Error / Success */}
//         {error && (
//           <p role="alert" className="mt-6 text-center text-red-600 font-semibold">
//             {error}
//           </p>
//         )}
//         {success && (
//           <p role="status" className="mt-6 text-center text-green-600 font-semibold">
//             {success}
//           </p>
//         )}
//       </form>
//     </main>
//   );
// };

// export default UploadArticle;


import React, { useState, useEffect } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db } from './firebaseConfig';

const UploadArticle = () => {
  const [title, setTitle] = useState('');
  const [mainDescription, setMainDescription] = useState('');
  const [iframeUrl, setIframeUrl] = useState(''); // ✅ New state for iframe
  const [subtopics, setSubtopics] = useState([
    { id: Date.now(), heading: '', description: '', imageFile: null, imagePreview: null },
  ]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(''), 5000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleAddSubtopic = () => {
    setSubtopics((prev) => [
      ...prev,
      { id: Date.now(), heading: '', description: '', imageFile: null, imagePreview: null },
    ]);
  };

  const handleRemoveSubtopic = (id) => {
    setSubtopics((prev) => prev.filter((sub) => sub.id !== id));
  };

  const handleSubtopicChange = (id, field, value) => {
    setSubtopics((prev) =>
      prev.map((sub) => (sub.id === id ? { ...sub, [field]: value } : sub))
    );
  };

  const handleImageChange = (id, file) => {
    if (file && file.type.startsWith('image/')) {
      const previewUrl = URL.createObjectURL(file);
      setSubtopics((prev) =>
        prev.map((sub) =>
          sub.id === id ? { ...sub, imageFile: file, imagePreview: previewUrl } : sub
        )
      );
    }
  };

  const validateForm = () => {
    if (!title.trim()) {
      setError('Please enter the main article title.');
      return false;
    }

    for (let i = 0; i < subtopics.length; i++) {
      const sub = subtopics[i];
      if (!sub.heading.trim()) {
        setError(`Subtopic #${i + 1}: Heading is required.`);
        return false;
      }
      if (!sub.description.trim()) {
        setError(`Subtopic #${i + 1}: Description is required.`);
        return false;
      }
    }
    return true;
  };

  // Upload image to Firebase Storage and return the download URL
  const uploadImageAndGetUrl = async (file) => {
    if (!file) return null;
    const storage = getStorage();
    const storageRef = ref(storage, `articleImages/${file.name}_${Date.now()}`);
    await uploadBytes(storageRef, file);
    const url = await getDownloadURL(storageRef);
    return url;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError('');
    setSuccess('');

    if (!validateForm()) return;

    setLoading(true);

    try {
      // Upload images and get their URLs
      const subtopicsWithImages = await Promise.all(
        subtopics.map(async (sub) => {
          const imageUrl = sub.imageFile ? await uploadImageAndGetUrl(sub.imageFile) : null;
          return {
            heading: sub.heading.trim(),
            description: sub.description.trim(),
            imageUrl,
          };
        })
      );

      await addDoc(collection(db, 'articles'), {
        title: title.trim(),
        mainDescription: mainDescription.trim(),
        iframeUrl: iframeUrl.trim() || null, // ✅ Store iframe
        subtopics: subtopicsWithImages,
        createdAt: serverTimestamp(),
      });

      setSuccess('Article uploaded successfully!');
      setTitle('');
      setMainDescription('');
      setIframeUrl('');
      setSubtopics([{ id: Date.now(), heading: '', description: '', imageFile: null, imagePreview: null }]);
    } catch (err) {
      setError(`Failed to upload article: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="max-w-3xl mx-auto p-4 font-sans">
      <h1 className="text-3xl font-bold mb-6 text-center text-gray-800">Upload Article</h1>

      <form onSubmit={handleSubmit} noValidate>
        {/* Main Title */}
        <div className="mb-6">
          <label htmlFor="title" className="block text-lg font-semibold text-gray-700 mb-2">
            Main Title <span className="text-red-600">*</span>
          </label>
          <input
            id="title"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            disabled={loading}
            placeholder="Enter main article title"
            className="w-full border border-gray-300 rounded-md p-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
            maxLength={150}
            required
          />
          <p className="text-sm text-gray-500 mt-1">{title.length} / 150 characters</p>
        </div>

        {/* Main Description (optional) */}
        <div className="mb-6">
          <label htmlFor="mainDescription" className="block text-lg font-semibold text-gray-700 mb-2">
            Main Description (optional)
          </label>
          <textarea
            id="mainDescription"
            value={mainDescription}
            onChange={(e) => setMainDescription(e.target.value)}
            disabled={loading}
            rows={4}
            placeholder="Optional description for the article"
            className="w-full border border-gray-300 rounded-md p-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
            maxLength={500}
          />
          <p className="text-sm text-gray-500 mt-1">{mainDescription.length} / 500 characters</p>
        </div>

        {/* Iframe URL (optional) */}
        <div className="mb-6">
          <label htmlFor="iframeUrl" className="block text-lg font-semibold text-gray-700 mb-2">
            Optional Iframe URL
          </label>
          <input
            id="iframeUrl"
            type="text"
            value={iframeUrl}
            onChange={(e) => setIframeUrl(e.target.value)}
            disabled={loading}
            placeholder="Enter iframe URL (example: https://tapeadsenjoyer.com/e/Mkwml79QgJimqp9/)"
            className="w-full border border-gray-300 rounded-md p-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Subtopics */}
        <div>
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">Subtopics</h2>

          {subtopics.map((subtopic, index) => (
            <div
              key={subtopic.id}
              className="border border-gray-300 rounded-md p-4 mb-6 relative bg-white shadow-sm"
            >
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-semibold text-gray-700">
                  Subtopic #{index + 1}
                </h3>
                {subtopics.length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleRemoveSubtopic(subtopic.id)}
                    disabled={loading}
                    className="text-red-600 hover:text-red-800 focus:outline-none"
                    aria-label={`Remove subtopic #${index + 1}`}
                  >
                    &times;
                  </button>
                )}
              </div>

              {/* Subtopic Heading */}
              <div className="mb-4">
                <label
                  htmlFor={`subHeading-${subtopic.id}`}
                  className="block font-medium text-gray-700 mb-1"
                >
                  Subtopic Heading <span className="text-red-600">*</span>
                </label>
                <input
                  id={`subHeading-${subtopic.id}`}
                  type="text"
                  value={subtopic.heading}
                  onChange={(e) =>
                    handleSubtopicChange(subtopic.id, 'heading', e.target.value)
                  }
                  disabled={loading}
                  maxLength={100}
                  placeholder="Enter subtopic heading"
                  className="w-full border border-gray-300 rounded-md p-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
                <p className="text-sm text-gray-500 mt-1">
                  {subtopic.heading.length} / 100 characters
                </p>
              </div>

              {/* Subtopic Description */}
              <div className="mb-4">
                <label
                  htmlFor={`subDescription-${subtopic.id}`}
                  className="block font-medium text-gray-700 mb-1"
                >
                  Description <span className="text-red-600">*</span>
                </label>
                <textarea
                  id={`subDescription-${subtopic.id}`}
                  value={subtopic.description}
                  onChange={(e) =>
                    handleSubtopicChange(subtopic.id, 'description', e.target.value)
                  }
                  disabled={loading}
                  rows={5}
                  maxLength={1500}
                  placeholder="Write the subtopic description"
                  className="w-full border border-gray-300 rounded-md p-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                  required
                />
                <p className="text-sm text-gray-500 mt-1">
                  {subtopic.description.length} / 1500 characters
                </p>
              </div>

              {/* Subtopic Image Upload (optional) */}
              <div className="mb-2">
                <label
                  htmlFor={`subImage-${subtopic.id}`}
                  className="block font-medium text-gray-700 mb-1"
                >
                  Optional Image
                </label>
                <input
                  id={`subImage-${subtopic.id}`}
                  type="file"
                  accept="image/*"
                  disabled={loading}
                  onChange={(e) =>
                    handleImageChange(subtopic.id, e.target.files?.[0] || null)
                  }
                  className="block"
                />
              </div>

              {/* Image Preview */}
              {subtopic.imagePreview && (
                <div className="mt-2">
                  <img
                    src={subtopic.imagePreview}
                    alt={`Preview for subtopic #${index + 1}`}
                    className="max-w-full max-h-48 rounded-md border border-gray-300"
                  />
                </div>
              )}
            </div>
          ))}

          <button
            type="button"
            onClick={handleAddSubtopic}
            disabled={loading}
            className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            + Add Subtopic
          </button>
        </div>

        {/* Submit */}
        <div className="mt-8">
          <button
            type="submit"
            disabled={loading}
            className={`w-full py-3 text-lg font-semibold rounded-md text-white ${
              loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'
            } focus:outline-none focus:ring-2 focus:ring-green-500`}
            aria-busy={loading}
          >
            {loading ? 'Uploading...' : 'Upload Article'}
          </button>
        </div>

        {/* Error / Success */}
        {error && (
          <p role="alert" className="mt-6 text-center text-red-600 font-semibold">
            {error}
          </p>
        )}
        {success && (
          <p role="status" className="mt-6 text-center text-green-600 font-semibold">
            {success}
          </p>
        )}
      </form>
    </main>
  );
};

export default UploadArticle;
